import theme from '../../theme'

const breakpointMd = '@media (min-width: 768px)'

export const formControlLabel = {
  alignItems: 'center',
  backgroundColor: 'white',
  border: 'solid',
  borderColor: theme.lightGrey,
  borderRadius: 1,
  borderWidth: 1,
  boxShadow: 'none',
  color: theme.darkGrey,
  flexDirection: 'row',
  fontFamily: theme.primaryFont,
  height: '100%',
  lineHeight: '1.2',
  margin: 0,
  padding: '15px',
  textDecoration: 'none',
  textTransform: 'none',
  transition: 'all 0.3s ease',
  width: '100%',
  [breakpointMd]: {
    flexDirection: 'column',
    padding: '15px 15px 25px 15px'
  },
  '&:hover': {
    boxShadow: '0 2px 10px 0 rgba(30, 30, 30, 0.4)',
    backgroundColor: theme.blue,
    borderColor: theme.blue,
    color: 'white',
    '& svg': {
      fill: 'white'
    }
  },
  '&:focus-within': {
    outline: '5px auto #005fcc',
    outlineOffset: '5px'
  },
  '&>span': {
    fontSize: '1rem',
    fontFamily: theme.primaryFont,
    [breakpointMd]: {
      fontSize: '1.5rem',
      paddingBottom: '16px'
    }
  }
}

export const radioGroup = {
  [breakpointMd]: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    rowGap: '40px'
  }
}

export const formControl = {
  marginTop: '40px'
}

export const typography = {
  body1: {
    fontSize: '1.5rem',
    fontFamily: theme.primaryFont
  }
}
